
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, Link, useLocation, useNavigationType } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";
import SessionPopup from "./SessionPopup"
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { toast } from 'react-toastify';
import Loader from "../components/loader";
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import SideMenu from "./student/SideMenu";

import { ToastContainer } from "react-toastify";


let { lambda, appname } = window.app
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};

// list position is saved when opening view/edit so coming back returns to the same page
const LIST_POSITION_KEY = "videoListPosition";
const DEFAULT_POSITION = { page: 1, perPage: 15, search: "" };
const getSavedListPosition = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(LIST_POSITION_KEY));
        return saved?.page && saved?.perPage ? { ...DEFAULT_POSITION, ...saved } : null;
    } catch {
        return null;
    }
};
const ManageTest = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const navigationType = useNavigationType(); // "POP" = browser back/forward
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [youtube, setYoutube] = useState(null);
    const [totalRows, setTotalRows] = useState(0);
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    //    const[usersearch, setUserSearch]  = useState("");

    const { searchedFlag, setSearchedFlag, isLoading, usersearch, setUserSearch, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [flag, setFlag] = useState(false);
    const [user, setUser] = useState("");
    // from view/edit (Back button or browser back): restore the saved page; from any other menu: page 1
    const [initialPosition] = useState(() => ((state?.restoreListPage || navigationType === "POP") && getSavedListPosition()) || DEFAULT_POSITION);
    const [page, setPage] = useState(initialPosition.page);
    const [perPage, setPerPage] = useState(initialPosition.perPage);
    const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
    const requestIdRef = useRef(0);

    useEffect(() => {
        // if (!localStorage.getItem("token")) navigate("/");
        setUserSearch(initialPosition.search);
        fetchData({ page: initialPosition.page, perPage: initialPosition.perPage, search: initialPosition.search });
    }, []);

    const fetchData = ({ page = 1, perPage: size = perPage, search = "" }) => {
        const requestId = ++requestIdRef.current;
        const token = localStorage.getItem("token")
        const searchQuery = search ? "&search=" + encodeURIComponent(search) : "";
        setIsLoading(true);
        axios.get(`${lambda}/lectureLibraryInfo?appname=${appname}&isDisplay=all&token=${token}${searchQuery}&paginate=true&pageNumber=${page}&pageSize=${size}`)
            .then(res => {
                // a newer request went out while this one was in flight - drop this response
                if (requestId !== requestIdRef.current) return;
                const result = res?.data?.result;
                if (result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                } else if (result) {
                    const rows = result?.data ?? [];

                    // page is past the end (e.g. last row on the page was deleted) - step back one page
                    if (rows.length === 0 && page > 1) {
                        setPage(page - 1);
                        fetchData({ page: page - 1, perPage: size, search });
                        return;
                    }

                    setData(rows);
                    // backend totalCount ignores the search filter; a short first page means that's every match
                    setTotalRows(search && page === 1 && rows.length < size ? rows.length : (result?.totalCount ?? rows.length));
                    setActiveSearch(search);
                    global.exportExcelData = result;
                }
                setIsLoading(false);
            }).catch(() => {
                if (requestId !== requestIdRef.current) return;
                setIsLoading(false);
            });
    };

    const saveListPosition = () => {
        localStorage.setItem(LIST_POSITION_KEY, JSON.stringify({ page, perPage, search: activeSearch }));
    };

    const clearSearch = () => {
        GetTimeActivity();
        setUserSearch("");
        setPage(1);
        setFlag(false);
        setTableErrMsg(false);
        fetchData({ page: 1 });
    }

    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        GetTimeActivity();
        setPage(newPage);
        fetchData({ page: newPage, search: activeSearch });
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        GetTimeActivity();
        setPerPage(newPerPage);
        setPage(1);
        fetchData({ page: 1, perPage: newPerPage, search: activeSearch });
    };

    const playVideo = (video) => {
        setShowVideoPopup(true);
        setYoutube(video);
    };

    const handleDeleteUser = (e, id) => {
        setDeleteUserId(id);
        setDeleteShow(true);
    };

    const handleDelete = async () => {
        setDeleteShow(false);
        try {
            await tmdbApi.llDelete(deleteUserId);
            setDeleteSuccess(true);
            fetchData({ page, search: activeSearch });
        } catch (err) {
            console.error(err);
        }
    };
    // const handleSearch = (e, flagggg) => {
    //     GetTimeActivity();
    //     let pageToFetch = 1;
    //     if (flagggg) {
    //         setcurrentPage(1);
    //     } else {
    //         pageToFetch = currentPage;
    //     }
    //     setmaxPageNumberLimit(5);
    //     setminPageNumberLimit(0);
    //     if (flagggg === "normalsearch") {
    //         setSearchedFlag(true);
    //     }
    //     setFlag(true);
    //     setTableErrMsg(false);
    //     if (usersearch === "") {
    //         fetchData(pageToFetch, 15);
    //     } else {
    //         setIsLoading(true);
    //         const token = localStorage.getItem("token");
    //         axios({
    //             method: 'GET',
    //             url: lambda + '/lectureLibraryInfo?appname=' + appname + "&search=" + encodeURIComponent(usersearch) +"&isDisplay=all"+ "&pageNumber=" + pageToFetch + "&assetcount=15&token=" + token,
    //         })
    //             .then(function (response) {
    //                 // debugger
    //                 if (response?.data?.result === "Invalid token or Expired") {
    //                     // localStorage.clear();
    //                     // navigate("/");
    //                     setShowSessionPopupup(true)
    //                 } else {
    //                     setUser(response?.data?.result?.data);
    //                     setData(response?.data?.result?.data ?? []);
    //                     setTotalRows(response?.data?.result?.totalCount || 0);
    //                     global.exportExcelData = response?.data?.result;
    //                     setIsLoading(false);
    //                 }
    //             }).catch((err) => {
    //                 console.log('error', err);
    //                 setTableErrMsg(true);
    //                 setIsLoading(false);
    //             });
    //     }
    // }



    const handleSearch = (e, flagggg) => {
        GetTimeActivity();

        const inputQuery = usersearch;

        // ✅ Empty / whitespace-only validation
        if (flagggg === "normalsearch" && inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        if (flagggg === "normalsearch") {
            setSearchedFlag(true);
        }

        setFlag(true);
        setTableErrMsg(false);

        // empty search text just reloads the full list
        setPage(1);
        fetchData({ page: 1, search: inputQuery.trim() });
    };


    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };

    const handleViewUser = (e, id) => {
        saveListPosition();
        navigate(`/viewlecturelibrary/${id}`);
    };
    const handleEditUser = (e, id) => {
        saveListPosition();
        navigate(`/editlecturelibrary/${id}`);
    };
    const handleAddUser = () => {
        localStorage.removeItem(LIST_POSITION_KEY); // after adding, the list opens on page 1
        navigate("/addlecturelibrary");
    };

    const columns = [
        {
            name: 'Thumbnail',
            selector: row => <div className="thumbnail"> <i className="mdi mdi-play" style={{ cursor: "pointer" }} onClick={() => playVideo(row.youtube)}></i><img src={row?.thumbnail} style={{ width: 80, height: 60, objectFit: 'cover' }} /> </div>,
        },
        { name: 'Topic', selector: row => row?.title, sortable: true },
        { name: 'Youtube Video URL', selector: row => row?.youtube, sortable: true },
        { name: 'Availability', selector: row => row?.availability?.toUpperCase(), sortable: true },
        { name: 'Created by', selector: row => row?.createdBy?.username, sortable: true },
        { name: 'Created', selector: row => row?.formattedDate, sortable: true },
        { name: 'Status', selector: row => row?.status, sortable: true },
        {
            name: 'Actions',
            cell: row => (
                <div className="d-flex">
                    {/* <a onClick={() => playVideo(row.youtube)} className='text-success action-button'><i className="mdi mdi-play font-size-18"></i></a> */}
                    <a onClick={e => handleViewUser(e, row.lecturelibraryid)} className='text-success action-button'><i className="mdi mdi-eye font-size-18"></i></a>
                    <a onClick={e => handleEditUser(e, row.lecturelibraryid)} className='text-danger action-button'><i className="mdi mdi-pencil font-size-18"></i></a>
                    <a onClick={e => handleDeleteUser(e, row.lecturelibraryid)} className='text-danger action-button'><i className="mdi mdi-delete font-size-18"></i></a>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                {showVideoPopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            zIndex: 1000,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => setShowVideoPopup(false)}
                    >
                        <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                            <iframe
                                width="100%"
                                height="450"
                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                    youtube
                                )}?autoplay=1&rel=0&modestbranding=1`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="Video Preview"
                            ></iframe>
                            <button className="video-btn-close"
                                onClick={() => setShowVideoPopup(false)}
                                style={{
                                    position: "absolute",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                }}
                            ><span className="material-symbols-outlined">close</span>

                            </button>
                        </div>
                    </div>
                )}
                {/* <div className="main-content user-management lecture-library" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 lecture-table breadcrumb" id="breadcrumb-row">
                            <div className="d-flex mb-4 align-items-center">
                                <div className="flex-grow-1">
                                    <h4 className="mb-2 card-title" id="breadcrumb-title">Video Library</h4>
                                </div>
                                <button className="create-quiz-btn border-0" onClick={handleAddUser}>ADD</button>
                            </div>

                            <div className="row align-items-center mb-4 pe-0">
                                <div className="col-lg-4">

                                </div>
                                <div className="col-lg-8 user-management video-search-bar pe-0">
                                    <div className="table-data">
                                        <div className="search-box mb-2 d-inline-block" id="search-box">
                                            <div className="position-relative">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={usersearch}
                                                    onChange={(e) => handleChange(e)}
                                                    placeholder="Search by Name or Email"
                                                    onKeyPress={handleKeypress}
                                                    id="search-input"
                                                />
                                                <button
                                                    className="fill_btn"
                                                    onClick={(e) => handleSearch(e, "normalsearch")}
                                                    id="search-btn">
                                                    <span className="material-icons search-icon">search</span>
                                                </button>
                                            </div>
                                            <div className="dataTables_length" id="datatable-length-reset">
                                                <button
                                                    className="fill_btn"
                                                    onClick={clearSearch}
                                                    id="reset-btn">
                                                    <span className="material-icons-outlined">sync</span>Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div><div className="text-sm-end" id="text-end"></div>
                            </div>




                            <DataTable
                                columns={columns}
                                data={data}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationDefaultPage={page}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                paginationPerPage={perPage}
                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                progressPending={isLoading}
                                progressComponent={<TableLoader />}
                                highlightOnHover
                                striped
                                responsive
                                noDataComponent={<div>
                                    <div className="empty-state-body empty-record"  >
                                        <div className="empty-state__message">
                                            <span className="material-icons">summarize</span>
                                            <p className="form-check font-size-16">No Video Found</p>
                                        </div>
                                    </div></div>}
                            />
                    </div>
                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        title="Are you sure you want to delete?"
                        onConfirm={handleDelete}
                        onCancel={() => setDeleteShow(false)}
                    />

                    <SweetAlert
                        show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title="Deleted Successfully"
                        onConfirm={() => setDeleteSuccess(false)}
                    />
                </div>
            </div>
            <Footer />
        </div> */}

                <div className="main-content user-management create-case video_library" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Video Library</h4>
                                        </div>

                                        <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser} id="add-user-btn">
                                                ADD
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ?
                                                <Loader /> :
                                                <>
                                                    <div className="row mb-2" id="table-header-row">
                                                        <div className="col-sm-4 button-block" id="button-block">
                                                            <div className="dataTables_length" id="datatable-length">

                                                                {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                                  onClick={handleExport} id="export-btn">
                                  <span className="material-icons">north_east</span>Export
                              </button> */}


                                                            </div>
                                                        </div>
                                                        <div className="col-sm-8">
                                                            <div className="search-box mb-2 d-inline-block" id="search-box">
                                                                <div className="position-relative">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={usersearch}
                                                                        onChange={(e) => handleChange(e)}
                                                                        placeholder="Search by topic"
                                                                        onKeyPress={handleKeypress}
                                                                        id="search-input"
                                                                    />
                                                                    <button
                                                                        className="fill_btn"
                                                                        onClick={(e) => handleSearch(e, "normalsearch")}
                                                                        id="search-btn">
                                                                        <span className="material-icons search-icon">search</span>
                                                                    </button>
                                                                </div>
                                                                <div className="dataTables_length" id="datatable-length-reset">
                                                                    <button
                                                                        className="fill_btn"
                                                                        onClick={clearSearch}
                                                                        id="reset-btn">
                                                                        <span className="material-icons-outlined">sync</span>Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="text-sm-end" id="text-end"></div>
                                                        </div>
                                                    </div>

                                                    <DataTable
                                                        columns={columns}
                                                        data={data}
                                                        pagination
                                                        paginationServer
                                                        paginationTotalRows={totalRows}
                                                        onChangePage={handlePageChange}
                                                        paginationPerPage={15}
                                                        paginationRowsPerPageOptions={[15]}
                                                        progressPending={isLoading}
                                                        progressComponent={<TableLoader />}
                                                        highlightOnHover
                                                        striped
                                                        responsive
                                                        noDataComponent={customNoRecords()}
                                                        persistTableHead
                                                    />

                                                </>}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        title="Are you sure you want to delete?"
                        onConfirm={handleDelete}
                        onCancel={() => setDeleteShow(false)}
                    />

                    <SweetAlert
                        show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title="Deleted Successfully"
                        onConfirm={() => setDeleteSuccess(false)}
                    />

                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />


                    <Footer id="footer" />
                </div>
            </div >
        </>

    );
};

export default ManageTest;